import React, { useState, useEffect } from 'react';

const MigrationNotice = () => {
  const [showNotice, setShowNotice] = useState(false);

  useEffect(() => {
    // Verificar si necesitamos mostrar el aviso de migración
    const migrationNoticeShown = localStorage.getItem('sanctum_migration_notice_shown');
    const hadOldTokens = localStorage.getItem('had_jwt_tokens');
    
    if (!migrationNoticeShown && (hadOldTokens || window.location.search.includes('migration=true'))) {
      setShowNotice(true);
    }
  }, []);

  const handleClose = () => {
    setShowNotice(false);
    localStorage.setItem('sanctum_migration_notice_shown', 'true');
    localStorage.removeItem('had_jwt_tokens');
  };

  if (!showNotice) return null;

  return (
    <div className="fixed top-0 left-0 w-full z-50 bg-blue-600 text-white p-4 shadow-lg">
      <div className="max-w-6xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <div>
            <h3 className="font-semibold text-sm">Sistema Actualizado</h3>
            <p className="text-sm opacity-90">
              Hemos mejorado la seguridad del sistema. Por favor, inicia sesión nuevamente.
            </p>
          </div>
        </div>
        <button
          onClick={handleClose}
          className="flex-shrink-0 ml-4 p-1 hover:bg-blue-500 rounded transition-colors"
          aria-label="Cerrar aviso"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default MigrationNotice;

